/**
 * LevelIcons — len NOVÉ ikony pre levely + mapovanie level → ikona (0–60) a tier → ikona.
 *
 * Staré ikony sa len referencujú menom (z BuzerIcons, príp. sprout z BadgeIcons).
 * NOVÉ ikony (NEW_LEVEL_ICONS) pridaj do `ICONS` v BuzerIcons.tsx:
 *     import { NEW_LEVEL_ICONS } from "./LevelIcons";
 *     Object.assign(ICONS, NEW_LEVEL_ICONS);
 * Potom funguje <BuzerIcon name="gamepad" /> aj všetky level ikony.
 *
 * Náhrady (emoji bez dobrej line-ikony, nahradené existujúcou — pokojne povedz a dokreslím):
 *   Lv60 🦄 „Transcendencia" → ai · tier "Majster" 🦾 → dumbbell
 *
 * Štýl: 24×24, stroke = currentColor, round cap/join (rovnako ako zvyšok sady).
 */

export const NEW_LEVEL_ICONS: Record<string, { label: string; cat: string; svg: string }> = {
  "gamepad": {
    "label": "Ovládač",
    "cat": "ucenie",
    "svg": "<rect x=\"3\" y=\"8\" width=\"18\" height=\"9\" rx=\"4.5\"/><line x1=\"7\" y1=\"11\" x2=\"7\" y2=\"14\"/><line x1=\"5.5\" y1=\"12.5\" x2=\"8.5\" y2=\"12.5\"/><circle cx=\"15.5\" cy=\"11.5\" r=\"0.9\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"17.5\" cy=\"13.5\" r=\"0.9\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "fuel": {
    "label": "Pumpa",
    "cat": "praca",
    "svg": "<path d=\"M5 20 V6 a2 2 0 0 1 2 -2 h4 a2 2 0 0 1 2 2 v14\"/><line x1=\"4\" y1=\"20\" x2=\"14\" y2=\"20\"/><rect x=\"7\" y=\"7\" width=\"4\" height=\"3.5\" rx=\"0.5\"/><path d=\"M13 9 h3 a1.5 1.5 0 0 1 1.5 1.5 V15 a1 1 0 0 0 2 0 V9 l-2 -2\"/>"
  },
  "train": {
    "label": "Vlak",
    "cat": "praca",
    "svg": "<rect x=\"4\" y=\"6\" width=\"12\" height=\"9\" rx=\"2\"/><path d=\"M16 9 h2 l2.5 3 v3 H16Z\"/><line x1=\"4\" y1=\"15\" x2=\"20.5\" y2=\"15\"/><circle cx=\"8\" cy=\"18\" r=\"1.5\"/><circle cx=\"16\" cy=\"18\" r=\"1.5\"/><line x1=\"6\" y1=\"9.5\" x2=\"14\" y2=\"9.5\"/>"
  },
  "bull": {
    "label": "Býk",
    "cat": "priroda",
    "svg": "<path d=\"M5.5 6 C8 5.5 8.5 8 8.3 9.3\"/><path d=\"M18.5 6 C16 5.5 15.5 8 15.7 9.3\"/><path d=\"M8 9 a4 4 0 0 0 8 0 v2.5 a4 4 0 0 1 -8 0Z\"/><circle cx=\"10.4\" cy=\"10.5\" r=\"0.6\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"13.6\" cy=\"10.5\" r=\"0.6\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "ban": {
    "label": "Zákaz",
    "cat": "ui",
    "svg": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><line x1=\"6.4\" y1=\"6.4\" x2=\"17.6\" y2=\"17.6\"/>"
  },
  "award": {
    "label": "Vyznamenanie",
    "cat": "socialne",
    "svg": "<path d=\"M8.5 3 H15.5\"/><path d=\"M9 3 L11.4 10\"/><path d=\"M15 3 L12.6 10\"/><circle cx=\"12\" cy=\"15.5\" r=\"5.5\"/><path d=\"M12 12.90 C12 14.84 12.76 15.6 14.70 15.6 C12.76 15.6 12 16.36 12 18.30 C12 16.36 11.24 15.6 9.30 15.6 C11.24 15.6 12 14.84 12 12.90 Z\"/>"
  },
  "ufo": {
    "label": "UFO",
    "cat": "priroda",
    "svg": "<ellipse cx=\"12\" cy=\"13\" rx=\"9\" ry=\"3\"/><path d=\"M7.5 12 a4.5 2.8 0 0 1 9 0\"/><circle cx=\"8\" cy=\"13\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"12\" cy=\"13.6\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"16\" cy=\"13\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><line x1=\"6.5\" y1=\"16\" x2=\"5\" y2=\"19\"/><line x1=\"17.5\" y1=\"16\" x2=\"19\" y2=\"19\"/>"
  },
  "robot": {
    "label": "Robot",
    "cat": "ucenie",
    "svg": "<rect x=\"6\" y=\"7\" width=\"12\" height=\"11\" rx=\"2\"/><line x1=\"12\" y1=\"4\" x2=\"12\" y2=\"7\"/><circle cx=\"12\" cy=\"3.5\" r=\"1\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"9.7\" cy=\"11\" r=\"1.3\"/><circle cx=\"14.3\" cy=\"11\" r=\"1.3\"/><line x1=\"9.7\" y1=\"15\" x2=\"14.3\" y2=\"15\"/>"
  },
  "infinity": {
    "label": "Nekonečno",
    "cat": "ui",
    "svg": "<path d=\"M12 12 C10.5 9.3 6.5 9.3 6.5 12 C6.5 14.7 10.5 14.7 12 12 C13.5 9.3 17.5 9.3 17.5 12 C17.5 14.7 13.5 14.7 12 12Z\"/>"
  },
  "swords": {
    "label": "Meče",
    "cat": "socialne",
    "svg": "<line x1=\"5\" y1=\"19\" x2=\"15.5\" y2=\"8.5\"/><line x1=\"19\" y1=\"19\" x2=\"8.5\" y2=\"8.5\"/><path d=\"M15.5 8.5 L17 5 L13.5 6.5Z\"/><path d=\"M8.5 8.5 L7 5 L10.5 6.5Z\"/><line x1=\"4\" y1=\"17\" x2=\"7\" y2=\"20\"/><line x1=\"20\" y1=\"17\" x2=\"17\" y2=\"20\"/>"
  },
  "rock": {
    "label": "Skala",
    "cat": "priroda",
    "svg": "<path d=\"M4 17 L7 9.5 L13 7.5 L19.5 11 L20 16 L15.5 19 H7Z\"/><path d=\"M7 9.5 L12 13 L19.5 11\"/><path d=\"M12 13 L11 19\"/>"
  },
  "chess": {
    "label": "Šach",
    "cat": "ucenie",
    "svg": "<circle cx=\"12\" cy=\"6\" r=\"2.3\"/><path d=\"M10.2 8 C9 9.5 9.4 11 11 12 L9.7 16 h4.6 L13 12 C14.6 11 15 9.5 13.8 8\"/><path d=\"M8 20 h8 l-1.2 -3.5 H9.2Z\"/>"
  },
  "scroll": {
    "label": "Zvitok",
    "cat": "ucenie",
    "svg": "<path d=\"M8 5 h9 a2 2 0 0 1 0 4 H8\"/><path d=\"M8 5 a2 2 0 0 0 -2 2 v10 a2 2 0 0 0 2 2 h9 a2 2 0 0 0 2 -2 v-2 a2 2 0 0 0 -2 -2\"/><line x1=\"10\" y1=\"12\" x2=\"15\" y2=\"12\"/><line x1=\"10\" y1=\"15\" x2=\"15\" y2=\"15\"/>"
  },
  "temple": {
    "label": "Chrám",
    "cat": "ucenie",
    "svg": "<path d=\"M3.5 9 L12 4 L20.5 9Z\"/><line x1=\"3.5\" y1=\"18.5\" x2=\"20.5\" y2=\"18.5\"/><line x1=\"5\" y1=\"9.5\" x2=\"5\" y2=\"18\"/><line x1=\"9\" y1=\"9.5\" x2=\"9\" y2=\"18\"/><line x1=\"15\" y1=\"9.5\" x2=\"15\" y2=\"18\"/><line x1=\"19\" y1=\"9.5\" x2=\"19\" y2=\"18\"/>"
  },
  "comet": {
    "label": "Kométa",
    "cat": "priroda",
    "svg": "<path d=\"M16.5 4.80 C16.5 6.74 17.26 7.5 19.20 7.5 C17.26 7.5 16.5 8.26 16.5 10.20 C16.5 8.26 15.74 7.5 13.80 7.5 C15.74 7.5 16.5 6.74 16.5 4.80 Z\"/><line x1=\"3\" y1=\"19\" x2=\"10\" y2=\"12\"/><line x1=\"6.5\" y1=\"20\" x2=\"11\" y2=\"15.5\"/><line x1=\"3\" y1=\"15\" x2=\"6.5\" y2=\"11.5\"/>"
  },
  "bolt": {
    "label": "Blesk",
    "cat": "priroda",
    "svg": "<path d=\"M13 3 L6 13 h5 l-2 8 L18 10 h-5Z\"/>"
  },
  "galaxy": {
    "label": "Galaxia",
    "cat": "priroda",
    "svg": "<path d=\"M12 12 C12 9.5 15.5 9.5 16 12.5 C16.6 16.5 10.5 18 7.5 14 C4.3 9.7 10.5 4.5 16 6 C21.5 7.5 21 15.5 16.5 18.5\"/><circle cx=\"12\" cy=\"12\" r=\"0.8\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "blackhole": {
    "label": "Čierna diera",
    "cat": "priroda",
    "svg": "<ellipse cx=\"12\" cy=\"12\" rx=\"9\" ry=\"3.2\" transform=\"rotate(-22 12 12)\"/><circle cx=\"12\" cy=\"12\" r=\"3.2\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "trident": {
    "label": "Trojzubec",
    "cat": "socialne",
    "svg": "<line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"21\"/><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"9\"/><path d=\"M7 4 V8 a5 4 0 0 0 10 0 V4\"/><path d=\"M7 4 L5.8 6\"/><path d=\"M17 4 L18.2 6\"/><line x1=\"9.5\" y1=\"14\" x2=\"14.5\" y2=\"14\"/>"
  },
  "ninja": {
    "label": "Ninja",
    "cat": "socialne",
    "svg": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><line x1=\"4.5\" y1=\"10.3\" x2=\"19.5\" y2=\"10.3\"/><line x1=\"5\" y1=\"13.8\" x2=\"19\" y2=\"13.8\"/><line x1=\"7.8\" y1=\"12.1\" x2=\"10.3\" y2=\"12.1\"/><line x1=\"13.7\" y1=\"12.1\" x2=\"16.2\" y2=\"12.1\"/>"
  },
  "lion": {
    "label": "Lev",
    "cat": "priroda",
    "svg": "<circle cx=\"12\" cy=\"12.5\" r=\"4.3\"/><circle cx=\"10.4\" cy=\"12\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"13.6\" cy=\"12\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><path d=\"M11 14 L12 15 L13 14\"/><line x1=\"16.30\" y1=\"12.50\" x2=\"19.20\" y2=\"12.50\"/><line x1=\"15.48\" y1=\"15.03\" x2=\"17.82\" y2=\"16.73\"/><line x1=\"13.33\" y1=\"16.59\" x2=\"14.22\" y2=\"19.35\"/><line x1=\"10.67\" y1=\"16.59\" x2=\"9.78\" y2=\"19.35\"/><line x1=\"8.52\" y1=\"15.03\" x2=\"6.18\" y2=\"16.73\"/><line x1=\"7.70\" y1=\"12.50\" x2=\"4.80\" y2=\"12.50\"/><line x1=\"8.52\" y1=\"9.97\" x2=\"6.18\" y2=\"8.27\"/><line x1=\"10.67\" y1=\"8.41\" x2=\"9.78\" y2=\"5.65\"/><line x1=\"13.33\" y1=\"8.41\" x2=\"14.22\" y2=\"5.65\"/><line x1=\"15.48\" y1=\"9.97\" x2=\"17.82\" y2=\"8.27\"/>"
  }
};

/** Číslo levelu (0–60) → názov ikony.  E=existujúca · B=badge · N=nová (NEW_LEVEL_ICONS)
 *  v30: mriežka sa rozšírila na **60 úrovní** s novými menami — táto mapa je RUČNÁ (neodvodzuje
 *  sa z `lib/levels.ts`!), takže po každej zmene mriežky sa MUSÍ prekľúčovať. Kľúč 0 = „Deň nula".
 *  Ikony sú vybrané k novým menám po tieroch (Zelenáč = rastlinné, Zapálenec = oheň, Vytrvalec =
 *  beh, Stroj = mechanika, Bojovník = zbroj, Majster = remeslo, Guru = myseľ, Šampión = pódium,
 *  Legenda = koruna, Vesmírny = vesmír, Super Godlike = blesk). Nepoužité ikony z minulých mriežok
 *  (train, ban, rock, scroll, fuel…) ostávajú definované v NEW_LEVEL_ICONS — nič sa nemaže.
 *  Drift stráži `lib/levels.test.ts` („LEVEL_ICON pokrýva presne 0…60"). */
export const LEVEL_ICON: Record<number, string> = {
  0: "egg",           // 🥚 Deň nula (Level 0, pred prvým levelom)  [E]
  // 🐣 Nováčik
  1: "egg",           // Totálne newbie  [E]
  2: "gamepad",       // Mačkanie tlačidiel  [N]
  3: "book",          // Tutoriálová úroveň  [E]
  4: "footprints",    // Ešte sa učí chodiť  [E]
  5: "thumbsup",      // Prvý boss padol  [E]
  // 🌱 Zelenáč — rastlinná postupnosť
  6: "sprout",        // Prvé výhonky  [B]
  7: "grow1",         // Klíčenie (Klíček)  [E]
  8: "grow2",         // Silnejšie korene (Sadenica)  [E]
  9: "grow3",         // Rastie každým dňom (Rastlinka)  [E]
  10: "flower",       // Rozkvitá  [E]
  // 🔥 Zapálenec — oheň
  11: "sparkles",     // Prvá iskra  [E]
  12: "candle",       // Sviečka  [E]
  13: "flame",        // Rozhorený plameň  [E]
  14: "sun",          // Slobodná vatra  [E]
  15: "fuel",         // Organizovaný požiar (riadené palivo)  [N]
  // 💪 Vytrvalec — beh
  16: "shoe",         // Prvé kilometre  [E]
  17: "bull",         // Neuhýba z cesty  [N]
  18: "run",          // Na dlhé trate  [E]
  19: "flag",         // Maratónec/Maratónkyňa — cieľová vlajka  [E]
  20: "mountain",     // Ultra bežec/Ultra bežkyňa  [E]
  // ⚙️ Stroj — mechanika
  21: "settings",     // Prvé ozubené koleso  [E]
  22: "wrench",       // Funkčný motor  [E]
  23: "robot",        // Beží na výkon  [N]
  24: "compass",      // Autopilot/Autopilotka  [E]
  25: "infinity",     // Perpetuum mobile  [N]
  // 🛡️ Bojovník — zbroj
  26: "cap",          // Výcvik dokončený  [E]
  27: "shield",       // V plnej zbroji  [E]
  28: "swords",       // V nasadení  [N]
  29: "trident",      // Gladiátor/Gladiátorka  [N]
  30: "award",        // Veterán bojísk/Veteránka bojísk  [N]
  // 🦾 Majster — remeslo
  31: "bookopen",     // Učeň/Učnica  [E]
  32: "pen",          // Pomocník majstra/Pomocníčka majsterky  [E]
  33: "ninja",        // Majster/Majsterka  [N]
  34: "music",        // Virtuóz/Virtuózka  [E]
  35: "chess",        // Veľmajster/Veľmajsterka  [N]
  // 🧠 Guru — myseľ
  36: "bulb",         // Začína chápať  [E]
  37: "brain",        // Hlboké poznanie  [E]
  38: "owl",          // Múdrosť  [B]
  39: "meditation",   // Vnútorný vhľad  [E]
  40: "sunrise",      // Osvietenie  [E]
  // 🏆 Šampión — pódium
  41: "dumbbell",     // Maká v úzadí  [E]
  42: "medal2",       // Prvé pódium  [E]
  43: "medal",        // Medailová forma  [E]
  44: "chart",        // Rekordy padajú  [E]
  45: "temple",       // Sieň slávy  [N]
  // 👑 Legenda — koruna
  46: "people",       // Spoznávajú ho/Spoznávajú ju  [E]
  47: "star",         // Známe meno  [E]
  48: "lion",         // Živá legenda  [N]
  49: "crown",        // Mýtus medzi ľuďmi  [E]
  50: "moon",         // Polobožstvo  [E]
  // 🌟 Vesmírny — vesmír
  51: "star2",        // Mýtus ožíva  [E]
  52: "ufo",          // Mimozemšťan/Mimozemšťanka  [N]
  53: "galaxy",       // Medzi hviezdami  [N]
  54: "comet",        // Kozmické rozmery  [N]
  55: "sparkles",     // Veľký tresk  [E]
  // ⚡ Super Godlike — blesk
  56: "bolt",         // Godlike  [N]
  57: "hourglass",    // Nad časom  [E]
  58: "blackhole",    // Nad priestorom  [N]
  59: "infinity",     // Nesmrteľnosť  [N]
  60: "ai",           // Transcendencia  [E]
};

/** Názov tieru → názov ikony */
export const TIER_ICON: Record<string, string> = {
  "Nováčik": "egg",               // 🐣  [E]
  "Zelenáč": "sprout",            // 🌱  [B]
  "Zapálenec": "flame",           // 🔥  [E]
  "Vytrvalec": "dumbbell",        // 💪  [E]
  "Stroj": "settings",            // ⚙️  [E]
  "Bojovník": "shield",           // 🛡️  [E]
  "Majster": "dumbbell",          // 🦾  [*]
  "Guru": "brain",                // 🧠  [E]
  "Šampión": "trophy",            // 🏆  [E]
  "Legenda": "crown",             // 👑  [E]
  "Vesmírny": "star2",            // 🌟  [E]  (v30 — premenované z „Mýtický")
  "Super Godlike": "bolt",        // ⚡  [N]
};

/**
 * Render:
 *   import { BuzerIcon } from "./BuzerIcons";
 *   import { LEVEL_ICON } from "./LevelIcons";
 *   <BuzerIcon name={LEVEL_ICON[user.level]} size={24} />
 *
 * --- Backend (Python), ak chceš nahradiť emoji za názvy ikon ---
 * LEVEL_ICON_PY = {   # v30 — 60 úrovní
 *   1:"egg", 2:"gamepad", 3:"book", 4:"footprints", 5:"thumbsup",
 *   6:"sprout", 7:"grow1", 8:"grow2", 9:"grow3", 10:"flower",
 *   11:"sparkles", 12:"candle", 13:"flame", 14:"sun", 15:"fuel",
 *   16:"shoe", 17:"bull", 18:"run", 19:"flag", 20:"mountain",
 *   21:"settings", 22:"wrench", 23:"robot", 24:"compass", 25:"infinity",
 *   26:"cap", 27:"shield", 28:"swords", 29:"trident", 30:"award",
 *   31:"bookopen", 32:"pen", 33:"ninja", 34:"music", 35:"chess",
 *   36:"bulb", 37:"brain", 38:"owl", 39:"meditation", 40:"sunrise",
 *   41:"dumbbell", 42:"medal2", 43:"medal", 44:"chart", 45:"temple",
 *   46:"people", 47:"star", 48:"lion", 49:"crown", 50:"moon",
 *   51:"star2", 52:"ufo", 53:"galaxy", 54:"comet", 55:"sparkles",
 *   56:"bolt", 57:"hourglass", 58:"blackhole", 59:"infinity", 60:"ai",
 * }
 */
